if (!customElements.get('checkout-btn')) {
  customElements.define('checkout-btn', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        setTimeout(() => this.init(), 100);
      }
    }

    init() {
      this.qtySelector = '.quantity-selector__input[name="quantity"]';
      this.anchor = this.querySelector('.checkout-btn');
      
      const qtyInput = document.querySelector(this.qtySelector);
      
      if (!qtyInput || !this.anchor) {
        console.warn('Checkout-btn: 数量输入框或按钮未找到');
        return;
      }

      const updateHref = () => {
        const quantity = qtyInput.value || 1;
        
        const variantIdInput = document.querySelector('input[name="id"]');
        const variantId = variantIdInput ? variantIdInput.value : new URLSearchParams(window.location.search).get('variant');
        
        if (variantId && this.anchor) {
          this.anchor.href = `/cart/${variantId}:${quantity}?return_to=/checkout`;
          console.log('链接已同步:', this.anchor.href);
        }
      };

      qtyInput.addEventListener('input', updateHref);
      qtyInput.addEventListener('change', updateHref);

      const idInput = document.querySelector('input[name="id"]');
      if (idInput) {
        idInput.addEventListener('change', updateHref);
      }

      updateHref();

      this.anchor.addEventListener('mouseenter', updateHref);
      this.anchor.addEventListener('touchstart', updateHref, {passive: true});
    }
  });
}